import { useTranslation } from 'react-i18next';
import { useChargePointsStore } from '../../store/charge-points-store';

/**
 * Navigation controls for cycling through overlapping markers
 * Shows "1 of 3" with arrow buttons
 */
export function OverlapNavigator() {
  const { t } = useTranslation();
  const overlapGroup = useChargePointsStore((s) => s.overlapGroup);
  const currentIndex = useChargePointsStore((s) => s.currentOverlapIndex);
  const selectNext = useChargePointsStore((s) => s.selectNextOverlap);
  const selectPrevious = useChargePointsStore((s) => s.selectPreviousOverlap);

  // Don't show if no overlaps
  if (!overlapGroup || overlapGroup.length <= 1) return null;

  const current = currentIndex + 1; // Display 1-based index
  const total = overlapGroup.length;

  return (
    <div className="flex items-center gap-2 px-3 py-2 bg-amber-50 dark:bg-amber-400/10 border-b border-amber-200 dark:border-amber-400/20">
      {/* Info icon */}
      <svg
        className="w-4 h-4 text-amber-600 flex-shrink-0"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fillRule="evenodd"
          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
          clipRule="evenodd"
        />
      </svg>

      <span className="text-sm text-amber-900 dark:text-amber-200 flex-1">
        {t('chargePoint.multipleAtLocation')}
      </span>

      {/* Navigation */}
      <div className="flex items-center gap-2">
        <button
          onClick={selectPrevious}
          className="p-1 rounded hover:bg-amber-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={total <= 1}
          aria-label="Previous location"
        >
          <svg
            className="w-4 h-4 text-amber-900 dark:text-amber-200"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        <span className="text-xs font-semibold text-amber-900 dark:text-amber-200 tabular-nums min-w-[3rem] text-center">
          {current} / {total}
        </span>

        <button
          onClick={selectNext}
          className="p-1 rounded hover:bg-amber-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={total <= 1}
          aria-label="Next location"
        >
          <svg
            className="w-4 h-4 text-amber-900 dark:text-amber-200"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
